export enum LoginType {
	DEFAULT,
	SSO, // TODO: use this type in case of SSO, separate it from default
	MITID,
	BANKID,
}
